/**
*   Custom JS
*/

document.addEventListener('DOMContentLoaded', () => {

    /**
    *   Subnavigation
    */
    function subnavigationToggle() {
        let buttons = document.querySelectorAll('.js-subnavigation-toggle');

        if (!buttons) return;

        buttons.forEach(button => {
            let subnavigation = button.parentElement.parentElement;

            button.addEventListener('click', function () {
                subnavigation.classList.toggle('subnavigation--open');
            });
        });
    }


    /**
    *   Featured Applications
    */
    function applicationLinkHover() {
        let containers = document.querySelectorAll('.js-featured-applications');

        if (!containers) return;

        containers.forEach(container => {
            let cards            = container.querySelectorAll('.collection-list__item');
            let previewContainer = container.querySelector('.js-featured-applications-preview');

            cards.forEach(card => {
                let image   = card.querySelector('.card__media img');

                card.addEventListener('mouseover', function () {
                    previewContainer.innerHTML = '';
                    previewContainer.appendChild(document.createElement('img')).srcset = image.srcset;
                });

                card.addEventListener('mouseout', function () {
                    previewContainer.innerHTML = '';
                    previewContainer.appendChild(document.createElement('img')).srcset = image.srcset;
                });
            });


        });

    }


    /**
    *   Fifty Fifty Height Toggles
    */
    function contentAccordions() {
        const toggles = document.querySelectorAll('.js-artek-fifty-toggle');

        if (!toggles) return;

        toggles.forEach(toggle => {
            let parent          = toggle.closest('.artek-fifty');
            let subcontentInner = toggle.parentElement.querySelector('.artek-fifty__subcontent-inner');
            let maxHeight       = 30;

            if (subcontentInner.childNodes) {
                subcontentInner.childNodes.forEach(c => { if (c.offsetHeight) maxHeight += c.offsetHeight });
            }

            toggle.onclick = () => {
                if (parent.classList.contains('artek-fifty--collapsed')) {
                    parent.classList.replace('artek-fifty--collapsed', 'artek-fifty--expanded')
                    subcontentInner.style.maxHeight = `${maxHeight}px`;

                    toggle.innerHTML = '-';

                } else {
                    parent.classList.replace('artek-fifty--expanded', 'artek-fifty--collapsed')
                    subcontentInner.style.maxHeight = '80px';
                    toggle.innerHTML = '+';
                }
            }
        });
    }

    /**
    *   FAQ Accordion
    */
    function faqAccordions() {
        const accordions = document.querySelectorAll('.js-faqs-list-item');

        if (!accordions) return;

        const openAccordion = (accordion) => {
            let content = accordion.querySelector('.faqs-list-item__content');

            accordion.classList.add('faqs-list-item--expanded');
            content.style.maxHeight = content.scrollHeight + 'px';
        }

        const closeAccordion = (accordion) => {
            let content = accordion.querySelector('.faqs-list-item__content');

            accordion.classList.remove('faqs-list-item--expanded');
            content.style.maxHeight = null;
        }

        accordions.forEach(accordion => {
            let toggle = accordion.querySelector('.faqs-list-item__title');
            let content = accordion.querySelector('.faqs-list-item__content');

            toggle.onclick = () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                } else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            }
        });
    }


    /**
    *   Variant Selectors
    */
    function selectAvailableVariant() {
        let container = document.querySelector('variant-radios');

        if (!container) return;

        let options          = container.querySelectorAll('input[data-option-position]');
        let productElement   = container.closest('[data-product]');
        let product          = JSON.parse(productElement.getAttribute('data-product'));
        let { variants }     = product;
        let hasOnlyOneOption = container.querySelector('[data-option-position="2"]') ? false : true;

        // Loop over all options
        options.forEach(radio => {
            let optionPosition = radio.getAttribute('data-option-position');

            radio.addEventListener('change', function() {
                let radios           = container.querySelectorAll('input[data-option-position]');
                let matchingVariants = [];
                let option1Default   = null;
                let option2Default   = null;
                let option3Default   = null;

                // loop over radios and set defaults
                radios.forEach(r => {
                    let position = r.getAttribute('data-option-position');

                    if (position == 1 && r.checked) option1Default = r.value;
                    if (position == 2 && r.checked) option2Default = r.value;
                    if (position == 3 && r.checked) option3Default = r.value;
                });

                // get matching variants for selected option
                if (optionPosition == 1) {
                    let exactMatch = variants.filter(v => {
                        return option2Default
                            ? v.option1 == radio.value && v.option2 == option2Default
                            : v.option1 == radio.value
                    });

                    // if no exact match, filter by last condition only
                    matchingVariants = exactMatch.length > 0
                        ? exactMatch
                        : variants.filter(v => { return v.option1 == radio.value });

                } else if (optionPosition == 2) {
                    let exactMatch = variants.filter(v => {
                        return option1Default
                            ? v.option1 == option1Default && v.option2 == radio.value
                            : v.option2 == radio.value
                    });

                    // if no exact match, filter by last condition only
                    matchingVariants = exactMatch.length > 0
                        ? exactMatch
                        : variants.filter(v => { return v.option2 == radio.value });

                } else if (optionPosition == 3) {
                    let exactMatch = variants.filter(v => {
                        return option1Default && option2Default
                            ? v.option1 == option1Default && v.option2 == option2Default && v.option3 == radio.value
                            : v.option3 == radio.value
                    });

                    // if no exact match, filter by last condition only
                    matchingVariants = exactMatch.length > 0
                        ? exactMatch
                        : variants.filter(v => { return v.option3 == radio.value });
                }


                if (container) {
                    let match = matchingVariants[0];

                    if (!match) return;

                    // clear previous selections
                    if (!hasOnlyOneOption) options.forEach(option => option.checked = false);

                    const { option1, option2, option3 } = match;

                    if (option1) {
                        let value  = option1.replace('"', '');
                        let option = container.querySelector(`input[value^="${value}"][data-option-position="1"]`);

                        if (option) option.checked = true;
                    }

                    if (option2) {
                        let value  = option2.replace('"', '');
                        let option = container.querySelector(`input[value^="${value}"][data-option-position="2"]`);

                        if (option) option.checked = true;
                    }

                    if (option3) {
                        let value  = option3.replace('"', '');
                        let option = container.querySelector(`input[value^="${value}"][data-option-position="3"]`);

                        if (option) option.checked = true;
                    }
                }
            })
        });
    }


    function setOptionOneAvailableVariants(container, variants, option2Default, option3Default) {
        if (!variants || !option2Default) return;

        let matches = variants.filter(v => {
            return option2Default && option3Default
                ? v.option2 == option2Default && v.option3 == option3Default
                : v.option2 == option2Default
        });

        matches = matches.map(v => { return v.option1 });

        container.querySelectorAll(`input[data-option-position="1"]`).forEach(radio => {
            matches.includes(radio.value)
                ? radio.classList.remove('disabled')
                : radio.classList.add('disabled');
        });
    }

    function removeUnavailableVariantClass(container) {
        if (!container) return;

        container.querySelectorAll(`input[data-option-position="1"]`).forEach(radio => {
            radio.classList.remove('disabled')
        });
    }


    // Trigger these functions when the DOM loads
    (function initializeOnLoad() {
        subnavigationToggle();
        applicationLinkHover();
        contentAccordions();
        faqAccordions();
        selectAvailableVariant();
    })();
});
